export const initialValues = {
    date: '',
    name: '',
    userId: '',
    id: '',
    course: '',
    subject: '',
    chapter: '',
    topic: '',
}

export interface formValues {
    course: string
    subject: any
    chapter: string
    topic: string
}

export const resetInitialValues = {
    course: false,
    subject: false,
    chapter: false,
    topic: false
}